

import { useState, useEffect } from "react";

import { Grid, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import { separadorMillares } from "../../../hooks/useMillares";
import { useParams } from "react-router-dom";
import { useOPXID } from "../../../hooks/cache";
import { LayoutTabla } from "../../layouts";





export const DetallesDeOp = ({ data }) => {


    const { id } = useParams();
    const { data:op } = useOPXID(id); 
    const [abonos, setAbonos] = useState(0)

    useEffect(() => {
        if( data.length > 0 ){
            const abn = data.reduce( (total, abono) => total + abono.abono, 0);
            setAbonos(abn);
        }
    }, [data] );
    


    return (

        <Grid container sx={{mb:3}}>
            {(op) &&
            <LayoutTabla>
                <TableHead >
                    <TableRow >
                        <TableCell sx={{width:'20%'}}>TIPO</TableCell>
                        <TableCell sx={{width:'15%'}}>IVA</TableCell>
                        <TableCell sx={{width:'15%'}}>SUBTOTAL</TableCell>
                        <TableCell sx={{width:'20%'}}>TOTAL</TableCell>
                        <TableCell sx={{width:'15%'}}>ABONOS</TableCell>
                        <TableCell sx={{width:'15%'}}>DEUDA</TableCell>
                    </TableRow>
                </TableHead>

                <TableBody>
                    <TableRow >
                        <TableCell>{ op?.view }</TableCell>
                        <TableCell>{ `$${separadorMillares(op.iva)}` }</TableCell>
                        <TableCell>{ `$${separadorMillares(op.subTotalOrden)}` }</TableCell>
                        <TableCell>{ `$${separadorMillares(op.totalOrden)}` }</TableCell>
                        <TableCell>{ `$${separadorMillares(abonos)}` }</TableCell>
                        <TableCell>{ `$${separadorMillares(op.deudaAdmin)}` }</TableCell>
                    </TableRow>
                </TableBody>
            </LayoutTabla>
            }
        </Grid>
    )
}
